import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { ViewApplicationDistributionFieldEnum } from 'Common/FieldEnum';
import { makeOptionsDataWithAll } from 'Common/FormHelper';
import { VIEW_APPLICATION_DISTRIBUTION_FORM_NAME } from 'Common/FormEnum';

const root = state => get(state, 'ViewApplicationDistributionState');

export const getFetching = state => get(root(state), 'fetching');
export const getFetchingResults = state => get(root(state), 'fetchingResults');
export const getFetchError = state => get(root(state), 'fetchError', null);
export const formValuesSelector = getFormValues(
  VIEW_APPLICATION_DISTRIBUTION_FORM_NAME
);
export const getViewApplicationDistributionFormValues = state =>
  formValuesSelector(state) || {};

// types
export const getTypes = state => get(root(state), 'types', []);
export const getTypeOptions = createSelector(
  getTypes,
  types => {
    const options = makeOptionsDataWithAll(types);
    options.unshift({ value: null, key: null, text: '' });
    return options;
  }
);
export const getSelectedTypeId = state => {
  const formValues = formValuesSelector(state);
  return formValues
    ? formValues[ViewApplicationDistributionFieldEnum.TypeId]
    : 1;
};

export const getResults = state => get(root(state), 'results', []);



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/state/selectors.js